module.exports = "<li class=\"inline-list__item\">\n    <a href=\"/<%=id%>\" class=\"button button--small button--tag button--secondary\" data-link-name=\"<%=index%> | <%=name%>\"><%=name%></a>\n</li>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/common/views/history/tag.html
// module id = 150
// module chunks = 0 1 15 17